<template>
    <span><span v-for="(num,index) in accountSelf" :key="index" class="acc-item">{{num}}</span></span>
</template>

<script>
export default {
    props:{
        account:{
            type:[String,Number],
            required: false,
            default: function() {
                return "";
            }
        }
    },
    name:"user-account",
    data() {
        return {}
    },
    computed:{
        accountSelf(){
            let res = [];
            if(this.account){
                res = this.slice(this.account);
            }
            return res;
        }
    },
    methods: {
        slice(acc) {
            return acc.toString().match(/.{1,4}/g) || [];
        }
    }
};
</script>
<style scoped>
.acc-item{
    margin-right: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/user-account/user-account.vue